import { postData, getData } from '@core/utils/http/general'
import store from '@/store'

//* Check current user's pass
// eslint-disable-next-line import/prefer-default-export
export const checkPassAccount = pass => new Promise((resolve, reject) => {
  const data = new FormData()
  data.append('task', 'wsCuenta')
  data.append('origin', process.env.VUE_APP_ORIGIN_API)
  data.append('token', store.state.cuenta.session.token)
  data.append('action', 1)
  data.append('x', pass)

  postData(data)
    .then(response => {
      if (response.status === 200) resolve(response.data)
      else reject(response.data.message)
    })
    .catch(err => { reject(err) })
})

/**
 * @name wsCheckawm
 */
export const wsCheckawm = task => new Promise((resolve, reject) => {
  const paramsRequest = {
    action: task,
    token: store.state.cuenta.session.token,
  }
  getData(paramsRequest, 'wsCuenta')
    .then(response => {
      if (response.status === 500) {
        reject(response.data.message)
      } else resolve(response.data)
    })
    .catch(err => { reject(err) })
})
